import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { getTraumaPlayerState } from "@/lib/trauma/attempts.functions";
import { isTraumaCourseId } from "@/lib/trauma/ids";
import { TraumaPlayer, type TraumaPlayerState } from "@/components/trauma/player";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";

export const Route = createFileRoute("/_authenticated/courses/trauma/$id/play")({
  loader: async ({ params }) => {
    if (!isTraumaCourseId(params.id)) throw notFound();
    let state;
    try {
      state = await getTraumaPlayerState({ data: { courseId: params.id } });
    } catch {
      throw redirect({ to: "/courses/trauma/$id", params: { id: params.id } });
    }
    if ("completedAttemptId" in state) {
      throw redirect({ href: `/courses/trauma/${params.id}/result/${state.completedAttemptId}` });
    }
    return state as TraumaPlayerState;
  },
  gcTime: 0,
  shouldReload: false,
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData ? `${loaderData.course.title} — د. سارة النحّاس` : "د. سارة النحّاس" },
      { name: "description", content: "دورة خاصة من سلسلة صدمات الطفولة من د. سارة النحّاس." },
      { property: "og:title", content: loaderData ? `${loaderData.course.title} — د. سارة النحّاس` : "دورات صدمات الطفولة — د. سارة النحّاس" },
      { property: "og:description", content: "دورة خاصة من سلسلة صدمات الطفولة." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: PlayPage,
});

function PlayPage() {
  const state = Route.useLoaderData();
  const { id } = Route.useParams();
  return <TraumaPlayer key={state.attemptId} courseId={id} state={state} />;
}
